import React, { useState } from 'react'

export default function TextShowMore(props) {
  const letterSize = 8.3
  const { text, width } = props
  const [showAll, setShowAll] = useState(false)

  if (!(typeof text === 'string')) {
    return text
  }

  if (text.length * letterSize < width) {
    return <span>{text}</span>
  }

  if (showAll) {
    return (
      <>
        <span>{text}</span>
        <a
          href="#setShowAll"
          data-hover="Show less"
          className="lox-hover-text"
          onClick={(e) => {
            e.preventDefault()
            setShowAll(!showAll)
          }}
        >
          {' '}
          …⤴︎
        </a>
      </>
    )
  }

  return (
    <>
      <span>{text.substring(0, Math.round(width / letterSize))}</span>
      <a
        data-hover="Show more"
        className="lox-hover-text"
        href="#setShowAll"
        onClick={(e) => {
          e.preventDefault()
          setShowAll(!showAll)
        }}
      >
        …⤵︎
      </a>
    </>
  )
}
